import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store";
import NoInternetConnection from "./views/pages/NoInternetConnection";
import "./assets/css/views/responsive.scss";
import * as Sentry from "@sentry/react";
import InactivateUser from "./reusable/InactivateUser";
import decryptData from "./reusable/decryptData";
import { ToastContainer } from 'react-toastify';
import { BrowserTracing } from "@sentry/tracing";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const loginuserid = decryptData();
const userid = loginuserid?.data?.id;
const sentry_token = loginuserid?.sentry_token;

if (process.env.REACT_APP_ENV === "PRODUCTION" || process.env.REACT_APP_ENV === "STAGING") {
  Sentry.init({
    dsn: sentry_token,
    environment: process.env.REACT_APP_ENV,
    tracesSampleRate: 1.0, 
    profilesSampleRate: 0.0,
    sendDefaultPii: true,
    release: "rams@1.0.0",
    integrations: [new BrowserTracing()],

    beforeSend(event) {
      if (event.transaction && event.transaction.startsWith("XHR") && event.level !== "error") {
        return null;
      }
      return event;
    },
  });

  Sentry.setUser({
    id: userid, // Set the user ID
  });
}

root.render(
  <React.Fragment>
    <Provider store={store}>
      <BrowserRouter>
        <NoInternetConnection>
          {/*{*/}
          {/*  process.env.REACT_APP_ENV === "PRODUCTION" ? <InactivateUser></InactivateUser> : ""*/}
          {/*}*/}
          <ToastContainer
            autoClose={1500}
          />
          <App />
        </NoInternetConnection>
      </BrowserRouter>
    </Provider>
  </React.Fragment>
);

reportWebVitals();
